/* app/page/homepage */

define( 
	'app/page/homepage',[
		'jquery',
		'app/ui/video/load',
		'magnificPopup'
	],

	function ($, VideoLoad) {
		var popup;
		var popUpVideoUrl;

		VideoLoad.init();

		//social feed
		$('.js-twitter-feed').on('click', function (e) {
			e.preventDefault();
			if ($('#twitter').hasClass('hidden')) {
				$('#facebook').addClass('hidden');
				$('#twitter').removeClass('hidden');
				$('.js-facebook-feed').removeClass('is-selected');
				$('.js-twitter-feed').addClass('is-selected');
			}
		});
		$('.js-facebook-feed').on('click', function (e) {
			e.preventDefault();
			if ($('#facebook').hasClass('hidden')) {
				$('#twitter').addClass('hidden');
				$('#facebook').removeClass('hidden');
				$('.js-twitter-feed').removeClass('is-selected');
				$('.js-facebook-feed').addClass('is-selected');
			}
		});
	}
);

